import React from 'react'
import Contactpage from '../Components/Contactpage'
import Footer from '../Components/Footer'

function Contact() {
  return (
   <>
     <Contactpage/>
     <Footer/>
   </>
  )
}

export default Contact
